import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-678748a9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "vtu-dashboard" }

import { computed, onMounted, watch } from "vue";
import { useStore } from "vuex";
import {
  setBreadcrumbLinks,
  setCurrentPageTitle,
} from "@/core/helpers/breadcrumb";
import { useDashboardMeta } from "@/core/hooks/useDashboardMeta";
import { useDashboardScope } from "@/core/hooks/useDashboardScope";
import { useDashboardCacheVersions } from "@/core/hooks/useDashboardCacheVersions";
import DashboardContentLayout from "@/components/dashboard/DashboardContentLayout.vue";
import DashboardLeftColumn from "@/components/dashboard/DashboardLeftColumn.vue";
import DashboardRightColumn from "@/components/dashboard/DashboardRightColumn.vue";
import DashboardMapPanel from "@/components/dashboard/DashboardMapPanel.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Dashboard',
  setup(__props) {

const store = useStore();
const {
  isLoading: metaLoading,
  isError: metaError,
  meta,
  refetch: refetchMeta,
} = useDashboardMeta();
const { scope, updateDateRange, resetToDefaultScope } = useDashboardScope();

useDashboardCacheVersions({ enabled: true });

const currentYear = computed(
  () => Number(store.getters.getSelectedYear) || new Date().getFullYear()
);

function onResetFocus(): void {
  if (!meta.value?.defaultScope || !scope.value) {
    return;
  }
  resetToDefaultScope(
    meta.value.defaultScope,
    scope.value.fromDate,
    scope.value.toDate
  );
}

onMounted(() => {
  setCurrentPageTitle("");
  setBreadcrumbLinks([], false);
  document.title = "Trang chủ - Đường sắt Hà Nội";
});

watch(currentYear, (year) => {
  if (!scope.value || !year) {
    return;
  }

  const stored = store.getters.getFilterDateRange as
    | { year: number; fromDate: string; toDate: string }
    | null
    | undefined;

  if (stored && stored.year === year) {
    if (
      scope.value.fromDate !== stored.fromDate ||
      scope.value.toDate !== stored.toDate
    ) {
      updateDateRange(stored.fromDate, stored.toDate);
    }
    return;
  }

  if (
    !scope.value.fromDate.startsWith(String(year)) ||
    !scope.value.toDate.startsWith(String(year))
  ) {
    const fromDate = `${year}-01-01`;
    const toDate = `${year}-12-31`;
    updateDateRange(fromDate, toDate);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(DashboardContentLayout, {
      "meta-loading": _unref(metaLoading),
      "meta-error": _unref(metaError),
      onRetryMeta: _unref(refetchMeta)
    }, {
      left: _withCtx(() => [
        _createVNode(DashboardLeftColumn)
      ]),
      center: _withCtx(() => [
        _createVNode(DashboardMapPanel, { onResetFocus: onResetFocus })
      ]),
      right: _withCtx(() => [
        _createVNode(DashboardRightColumn)
      ]),
      _: 1
    }, 8, ["meta-loading", "meta-error", "onRetryMeta"])
  ]))
}
}

})